// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".my-dialog[data-v-31f4befe]  .el-dialog__header .el-dialog__headerbtn{z-index:10}.my-dialog[data-v-31f4befe]  .el-dialog__body{padding:10px 20px 20px}.my-dialog .head[data-v-31f4befe]{font-size:16px;color:#333;font-weight:700;margin-bottom:16px;line-height:1em}.my-dialog .foot[data-v-31f4befe]{text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
